const UPDATED_REVIEW_STATUS = {
  decision_reverted_accepted: "Decision Reverted - Accepted",
  decision_reverted_declined: "Decision Reverted - Declined",
};

export { UPDATED_REVIEW_STATUS };
